import Vapi from 'vuex-rest-api'
const moles = new Vapi({
  baseURL: '/api/v2/tunnels',
  state: {
    moles: [],
    tunnels: [],
    terminals: [],
    tunnel: {},
  },
}).get({
  action: 'listMoles',
  property: 'moles',
  path: '/Moles',
  onSuccess (state, payload, axios, { params, data }) {
    state.moles = payload.data.data
    var tunnels = []
    var terminals = []
    state.moles.forEach((mole) => {
      if (mole.connections !== undefined && mole.connections !== null) {
        mole.connections.forEach((tunnel) => {
          const nTunnel = Object.assign({}, tunnel)
          nTunnel.mole = mole.hostname
          tunnels.push(nTunnel)
        })
      }
      if (mole.terminals !== undefined && mole.terminals !== null) {
        mole.terminals.forEach((terminal) => {
          const nTerminal = Object.assign({}, terminal)
          nTerminal.mole = mole.hostname
          terminals.push(nTerminal)
        })
      }
    })
    state.tunnels = tunnels
  },
  onError (state, error, axios, { params, data }) {
    state.moles = null
  },
}).post({
  action: 'createTunnel',
  property: 'tunnel',
  path: ({ esn }) => `/Tunnels/${esn}`,
  onSuccess (state, payload, axios, { params, data }) {
    console.log(payload)
    state.tunnel = payload.data.data
  },
  onError (state, error, axios, { params, data }) {
    console.error(error.response.data)
    if (error.response.data.message !== undefined && error.response.data.message !== null) {
      state.error.tunnel.message = error.response.data.message
      setTimeout(function () {
        state.error.tunnel = null
      }, 5000)
    }
    state.tunnel = {}
  },
}).post({
  action: 'createTunnelGuid',
  property: 'tunnel',
  path: ({ esn, guid }) => `/Tunnels/${esn}/${guid}`,
  onSuccess (state, payload, axios, { params, data }) {
    console.log(payload)
    state.tunnel = payload.data.data
  },
  onError (state, error, axios, { params, data }) {
    console.log(error.response.data)
    if (error.response.data.message !== undefined && error.response.data.message !== null) {
      state.error.tunnel.message = error.response.data.message
    }
    state.tunnel = {}
  },
}).post({
  action: 'createTerminal',
  property: 'terminal',
  path: ({ key }) => `/Terminals/${key}`,
  onSuccess (state, payload, axios, { params, data }) {
    console.log(payload)
    state.terminal = payload.data.data
  },
  onError (state, error, axios, { params, data }) {
    console.error(error.response.data)
    if (error.response.data.message !== undefined && error.response.data.message !== null) {
      state.error.terminal.message = error.response.data.message
      setTimeout(function () {
        state.error.terminal = null
      }, 5000)
    }
    state.terminal = {}
  },
}).delete({
  action: 'closeTunnel',
  property: 'tunnel',
  path: ({ esn }) => `/Tunnels/${esn}`,
  onSuccess (state, payload, axios, { params, data }) {
    console.log(payload)
    state.tunnel = payload.data.data
  },
  onError (state, error, axios, { params, data }) {
    console.log(error.response.data)
    if (error.response.data.message !== undefined && error.response.data.message !== null) {
      state.error.tunnel.message = error.response.data.message
    }
    state.tunnel = {}
  },
}).delete({
  action: 'closeTunnelGuid',
  property: 'tunnel',
  path: ({ esn, guid }) => `/Tunnels/${esn}/${guid}`,
  onSuccess (state, payload, axios, { params, data }) {
    console.log(payload)
    state.tunnel = payload.data.data
  },
  onError (state, error, axios, { params, data }) {
    console.log(error.response.data)
    if (error.response.data.message !== undefined && error.response.data.message !== null) {
      state.error.tunnel.message = error.response.data.message
    }
    state.tunnel = {}
  },
}).delete({
  action: 'closeTerminal',
  property: 'terminal',
  path: ({ esn, guid }) => `/Terminals/${esn}/${guid}`,
  onSuccess (state, payload, axios, { params, data }) {
    console.log(payload)
    state.terminal = payload.data.data
  },
  onError (state, error, axios, { params, data }) {
    console.log(error.response.data)
    if (error.response.data.message !== undefined && error.response.data.message !== null) {
      state.error.terminal.message = error.response.data.message
    }
    state.terminal = {}
  },
}).getStore({ namespaced: true })

export default moles
